import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import icon from "../../../assets/images/portal/icon.png";
import {
  FaHome,
  FaPlus,
  FaQuestionCircle,
  FaSignInAlt,
  FaTicketAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { Logout, getData } from "actions";
import { AuthContext } from "context/AuthContext";
import { useDispatch } from "react-redux";
import { API_URL_companysetting } from "constants/api";
import { companySettingReducers } from "redux/companySettingSlice";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Navbar = ({ current, isGradient = false }) => {
  const [IS_AUTH, setIS_AUTH] = useState(true);
  const { datauser } = useContext(AuthContext);
  const dispatch = useDispatch();

  const handleLogout = () => {
    Logout();
  };

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_companysetting,
        params,
        { dispatch, redux: companySettingReducers },
        "GET_COMPANYSETTING"
      );
    },
    [dispatch]
  );
  const fetchData = useCallback(() => {
    //get id 1 for setting
    const params = `1/`;
    get(params);
  }, [get]);

  const handleToDashboard = () => {
    const agentPage = datauser.group_permissions.includes("access_menu_agent");
    const adminPage = datauser.group_permissions.includes("access_menu_admin");
    if (agentPage && adminPage) {
      window.location.href = "/dashboard/agent";
    } else if (agentPage && !adminPage) {
      window.location.href = "/dashboard/agent";
    } else {
      window.location.href = "/administrator/dashboard/admin";
    }
  };

  const navigation = [
    {
      name: "Beranda",
      href: "/",
      current: current === "Beranda" ? true : false,
      icon: <FaHome />,
    },
    {
      name: "Pertanyaan & Jawaban",
      href: "/pertanyaan",
      current: current === "Pertanyaan & Jawaban" ? true : false,
      icon: <FaQuestionCircle />,
    },

    ...(IS_AUTH
      ? [
          {
            name: "Buat Tiket",
            href: "/buattiket",
            current: current === "Buat Tiket" ? true : false,
            icon: <FaPlus />,
          },
          {
            name: "Tiket Saya",
            href: "/tiketsaya",
            current: current === "Tiket Saya" ? true : false,
            icon: <FaTicketAlt />,
          },
        ]
      : []),
  ];
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (datauser !== "") {
      setIS_AUTH(true);
    } else {
      setIS_AUTH(false);
    }
  }, [datauser]);
  return (
    <Disclosure
      as="nav"
      className={
        isGradient === true
          ? "bg-gradient-to-b from-sky-700 to-sky-900"
          : "bg-sky-800"
      }
    >
      {({ open }) => (
        <>
          <div className="mx-auto max-w-[90rem] px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex items-center flex-1 mt-2 justify-center sm:items-stretch">
                <div
                  id="icon"
                  className="flex flex-shrink-0 items-center sm:mr-auto"
                >
                  <img
                    className="block h-12 w-auto lg:hidden"
                    src={icon}
                    alt="APJII"
                  />
                  <img
                    className="hidden h-12 w-auto lg:block"
                    src={icon}
                    alt="APJII"
                  />
                </div>
                <div id="menu" className="hidden sm:ml-6 sm:block sm:m-auto">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={classNames(
                          item.current
                            ? "font-bold text-white"
                            : "text-gray-300 hover:text-white ",
                          "rounded-md px-3 py-2 text-sm"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        <div
                          className={`flex items-center gap-1 ${
                            item.current ? "border-white" : "border-sky-800"
                          } border-b-2`}
                        >
                          {item.icon}
                          {item.name}
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3 mt-2">
                  <div>
                    {IS_AUTH ? (
                      <Menu.Button className="flex rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="sr-only bg-black">Open user menu</span>
                        <img
                          className=" h-10 w-10 rounded-full border border-blue-500"
                          src={datauser.profile_pic ?? datauser.avatar}
                          alt=""
                        />
                      </Menu.Button>
                    ) : (
                      <a href="https://sso.apjii.or.id/realms/auth-sso/protocol/openid-connect/auth?client_id=apjii-ticket&response_type=code&redirect_uri=https://tiket.apjii.or.id&scope=openid%20profile%20email">
                        <button className="button-login hidden md:block">
                          Login SSO APJII
                        </button>
                        <div className=" block md:hidden">
                          <FaSignInAlt className=" text-3xl text-white " />
                          <span className="text-white">Login</span>
                        </div>
                      </a>
                    )}
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-[-0.8rem] lg:right-[-3rem] lg:mr-5 z-50 mt-2 w-36 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        <div className="text-center mb-5">
                          <img
                            className=" h-16 w-16 rounded-full border shadow shadow-gray-900 text-center m-auto mb-3 mt-2"
                            src={datauser.profile_pic ?? datauser.avatar}
                            alt=""
                          />
                          <p className="mb-1 text-xs">Hello</p>
                          <div className="">
                            <span className="text-xs font-bold">
                              {datauser.username}
                            </span>
                          </div>
                        </div>
                      </Menu.Item>
                      {(datauser &&
                        datauser.group_permissions.includes(
                          "access_menu_admin"
                        )) ||
                      (datauser &&
                        datauser.group_permissions.includes(
                          "access_menu_agent"
                        )) ? (
                        <Menu.Item>
                          {({ active }) => (
                            <Link
                              onClick={() => handleToDashboard()}
                              className={classNames(
                                active ? "bg-sky-700" : "bg-sky-600",
                                "block px-4 py-2 text-sm text-white text-center rounded shadow-md shadow-sky-900 mx-5 mb-4"
                              )}
                            >
                              Dashboard
                            </Link>
                          )}
                        </Menu.Item>
                      ) : (
                        ""
                      )}

                      <Menu.Item>
                        {({ active }) => (
                          <Link
                            onClick={() => handleLogout()}
                            className={classNames(
                              active ? "bg-red-700" : "bg-red-600",
                              "block px-4 py-2 text-sm text-white text-center rounded shadow-md shadow-red-900 mx-5 mb-4"
                            )}
                          >
                            Sign out
                          </Link>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
            <hr className="mt-2 py-3 border-t-2" />
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="relative space-y-1 px-2 pb-3 pt-2 bg-sky-950 z-50">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  as="Link"
                  to={item.href}
                  className={classNames(
                    item.current
                      ? "font-bold text-white underline underline-offset-4"
                      : "text-gray-300 hover:underline hover:underline-offset-4 hover:text-white",
                    "block rounded-md px-3 py-2 text-base"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
};

export default Navbar;
